export function getUserTraits() {
  if (!window.analytics || !window.analytics.user || !window.analytics.user().traits) {
    return {};
  }
  const userTraits = (window.analytics.user().traits() as any) || {};
  return Object.keys(userTraits).reduce(
    (acc, trait) => {
      const key = `trait_${trait}`;
      acc[key] = userTraits[trait];
      return acc;
    },
    {} as Record<string, any>
  );
}

export function getAnonymousId() {
  // Segment generates an anonymousId for us when we call identify without an authToken.
  // We can retrieve it from the analytics object.
  return typeof window?.analytics?.user === "function"
    ? window.analytics?.user()?.anonymousId() || ""
    : "";
}

export function setAnonymousId(anonymousId: string) {
  // If we have an anonymousId, set it on Segment.
  if (typeof window?.analytics?.setAnonymousId === "function") {
    window.analytics.setAnonymousId(anonymousId);
  }
}

export async function identify(traits: Record<string, any> = {}) {
  // Segment's identify method allows us to set user traits and an anonymousId.
  // If we don't have an authToken, we can call identify with an empty object to generate a new anonymousId.
  if (typeof window?.analytics?.identify === "function") {
    await window.analytics.identify(traits);
  }
}
